
import ArchiveSlash from "../../../assets/outline/ArchiveSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArchiveSlashIcon({ className, dataTestid = "ArchiveSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArchiveSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
